import { ReporteRutas, GetResponseBody, GetHeaderRequest } from './RutasConfig';

export const SetParametrosReporte = async (pToken, pParametros) => {
    const result = await fetch(ReporteRutas.SetParametrosReporte, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(pParametros)
    });
    return await GetResponseBody(result);
};